<template>
	<div class="stamp" :style="style">
		{{ stamp.text }}
	</div>
</template>

<script>
export default {
	props: {
		stamp: { required: true, type: Object }
	},
	data() {
		return {
			style: {
				transform: `translate(-${this.stamp.left}%,-${this.stamp.top}%)`,
				top: `${this.stamp.top}%`,
				left: `${this.stamp.left}%`
			}
		};
	}
};
</script>

<style lang="scss" scoped>
.stamp {
	position: absolute;
	color: $white;
	font-size: 9px;
	font-family: $font-text-heavy;
	font-weight: lighter;
	width: 80px;
	height: 80px;
	display: flex;
	justify-content: flex-end;
	align-items: flex-end;
	border: 1px solid $white;
	z-index: 3;

	@include res(mobile) {
		width: 65px;
		height: 65px;
		font-size: 11px;
	}
}
</style>
